"use client";

import { useFaireDirectBrand } from "@faire/deprecated-retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { home } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { SignupFormContainer } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import { useSignUpEventTracker } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpEventTracker";
import { useSignUpStepsStore } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/SignUpStepsContext";
import { Step } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import openWithFaire from "@faire/web-api--source/routes/www/open-with-faire";
import { useStrictLocalization } from "@faire/web/common/localization";
import { LinkFormatting } from "@faire/web/common/localization/formatting";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect } from "react";

export const ConsumerStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();

  const { trackView } = useSignUpEventTracker(Step.CONSUMER);
  const [, setSignUpStepsStore] = useSignUpStepsStore([]);
  const { faireDirectBrand } = useFaireDirectBrand();

  useEffect(() => {
    trackView();
  }, [trackView]);

  useEffect(() => {
    setSignUpStepsStore({
      currentStep: Step.CONSUMER,
    });
  }, [setSignUpStepsStore]);

  return (
    <SignupFormContainer>
      <Column>
        <SignUpTitle
          title={strictLocalize({
            id: "zX131v",
            defaultMessage: "Faire is only available to retailers",
            description: {
              img: "https://cdn.faire.com/fastly/4f9fc48d202c6a65b9270fe8aa792b4f201a25ef3836005c2b6600d7be3552c5.png",
              text: "Title for the consumer step in the retailer signup flow",
            },
          })}
        />
        <Spacer height="3x" />
        <Typography>
          <StrictLocalMsg
            id="XYNxKA"
            defaultMessage="Faire is a wholesale marketplace designed for retail shops to find and order inventory for their stores."
          />
        </Typography>
        <Spacer size="2x" />
        <Typography>
          {faireDirectBrand ? (
            <StrictLocalMsg
              id="G01V1e"
              defaultMessage="If you aren’t a retailer but want to shop products from {fdBrandCompanyName}, we’d encourage you to <LinkFormatting>check out their website</LinkFormatting> or find them at a local store near you!"
              description={{
                text: "Text for the consumer step in the faire direct signup flow",
                img: "https://cdn.faire.com/fastly/c74614dc75007c0242c6980a29adcd51ad1f2fc00031ebb1154af9d342a59c3b.png",
              }}
              values={{
                fdBrandCompanyName: faireDirectBrand.name ?? "",
                LinkFormatting: LinkFormatting(faireDirectBrand.url ?? home()),
              }}
            />
          ) : (
            <StrictLocalMsg
              id="l5Q4ra"
              defaultMessage="If you are interested in starting a Retailer store Faire can help you! We have a program called Open With Faire that can help new retailers open their dream store."
              description={{
                text: "Text for the consumer step in the retailer signup flow",
                img: "https://cdn.faire.com/fastly/3fcfa119196d32cbdd2d8a056499ac83e163338ef174a57243990c71c5bf5721.png",
              }}
            />
          )}
        </Typography>
        <Spacer height="5x" />
        <Button linkTo={openWithFaire()}>
          <StrictLocalMsg id="7DIW6+" defaultMessage="Learn More" />
        </Button>
      </Column>
    </SignupFormContainer>
  );
};
